import * as React from 'react'
import { cn } from '@utils';

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {
	backButton?: React.ReactNode;
}

const PageContent = React.forwardRef<HTMLDivElement, PageContentProps>(({ className, backButton, ...props }, ref) => (
	<div
		ref={ref}
		className={cn('h-full w-full flex-1 overflow-y-auto relative', className)}
		data-aid="page-content"
		{...props}
	>
		{backButton ? (
			<div className="mb-5 fixed xs:hidden lg:block">
				<div className="absolute top-5 left-5">{backButton}</div>
			</div>
		) : (
			<React.Fragment />
		)}
		{props.children}
	</div>
));
PageContent.displayName = 'PageContent';

const PageContentMain = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn('p-3 md:p-5 h-auto', className)} data-aid="page-content-main" {...props} />
	)
);
PageContentMain.displayName = 'PageContentMain';

export { PageContent, PageContentMain };
